import {
  LOGOUT,
  PERMISSIONS_FETCH_START,
  PERMISSIONS_FETCH_SUCCESS,
  PERMISSIONS_FETCH_FAIL,
  PERMISSIONS_FRUIT_MODE,
  PERMISSIONS_RESET,
} from "../actions/types";
import {
  normalizeMePermissionsPayload,
  readLocalSessionRole,
} from "../../helpers/mePermissionsNormalize";

const initialState = {
  loaded: false,
  loading: false,
  error: null,
  isSuperAdmin: false,
  storeId: null,
  staffJob: null,
  permissions: null,
  hint: null,
  message: null,
  fruitMode: false,
};

export default function permissions(state = initialState, action) {
  switch (action.type) {
    case PERMISSIONS_FETCH_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case PERMISSIONS_FETCH_SUCCESS: {
      const p = normalizeMePermissionsPayload(action.payload || {});
      return {
        ...state,
        loaded: true,
        loading: false,
        error: null,
        isSuperAdmin: Boolean(p.isSuperAdmin),
        storeId: p.storeId ?? null,
        staffJob: p.staffJob ?? null,
        permissions: p.permissions ?? null,
        hint: p.hint ?? null,
        message: p.message ?? null,
        fruitMode: false,
      };
    }
    case PERMISSIONS_FETCH_FAIL: {
      const role = readLocalSessionRole();
      const fallbackSuper = role === 1;
      return {
        ...state,
        loaded: true,
        loading: false,
        error: action.payload?.message || "Failed to load permissions",
        isSuperAdmin: fallbackSuper,
        permissions: null,
        fruitMode: false,
      };
    }
    case PERMISSIONS_FRUIT_MODE:
      return {
        ...initialState,
        loaded: true,
        loading: false,
        fruitMode: true,
      };
    case PERMISSIONS_RESET:
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
}
